module.exports = __webpack_public_path__ + "img/Dach ausgebaut.b05f7fff.svg";